
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/investments-move",
      function () {
        return require("private-next-pages/docs/investments-move/index.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/investments-move"])
      });
    }
  